module.exports = __webpack_public_path__ + "static/media/pwclogo.0e936e6b.jpg";